import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';
import { CardsFilter, FilterTypes } from '../cards';

const APIs = {
  'special offers': EcomEngineAPI.entry.getSpecialOffers,
  events: EcomEngineAPI.entry.getEvents,
};

const NationalCardsFilter = ({
  siteFilter,
  type = 'special offers',
  viewAll = false,
}) => {
  const [cardsData, setCardsData] = useState([]);
  const [status, setStatus] = useState('idle');
  const [siteHandle, setSiteHandle] = useState('');
  const [page, setPage] = useState(1);
  const perPage = 12;
  const start = viewAll ? (page - 1) * perPage : 0;
  const end = viewAll ? start + perPage : cardsData.length;

  let pagination = null;
  if (viewAll && type === 'events' && cardsData.length > perPage) {
    pagination = {
      page,
      perPage,
      total: cardsData.length,
      onChange: (selected) => setPage(selected),
    };
  }

  useEffect(() => {
    setCardsData([]);
    setStatus('loading');
    setPage(1);

    APIs[type]({ site: siteHandle })
      .then((res) => {
        setCardsData(res);
        setStatus('succeed');
      })
      .catch((error) => {
        trackError(error);
        setStatus('failed');
      });
  }, [siteHandle, type]);

  const emptyState = (
    <div className="d-flex flex-column align-items-center gap-3 mt-5">
      <p className="fw-bold text-x-large">
        Sorry, no {type} found
        {siteHandle !== '' && (
          <>
            {' '}
            for{' '}
            {
              siteFilter.options.find((option) => option.value === siteHandle)
                ?.label
            }
          </>
        )}
      </p>
      <p>Try adjusting your filter to find other {type}</p>
      <Button variant="outline-primary" onClick={() => setSiteHandle('')}>
        Reset filter
      </Button>
    </div>
  );

  const moreLink =
    !viewAll && type === 'events' ? (
      <div className="d-flex justify-content-center mt-5">
        <a
          className="btn btn-outline-primary"
          href={`${window.location.pathname.replace(/\/+$/, '')}/all`}
        >
          View all events
        </a>
      </div>
    ) : null;

  const filterArray = [
    {
      ...siteFilter,
      onChange: ({ value }) => setSiteHandle(value),
      initialValue: siteHandle,
    },
  ];

  return (
    <CardsFilter
      filters={filterArray}
      cards={cardsData.slice(start, end)}
      cardAttrs={{
        hidePrice: true,
      }}
      fetchStatus={status}
      emptyState={emptyState}
      pagination={pagination}
      moreLink={moreLink}
    />
  );
};

export { NationalCardsFilter };

NationalCardsFilter.propTypes = {
  siteFilter: PropTypes.shape(FilterTypes),
  type: PropTypes.oneOf(['special offers', 'events']),
  viewAll: PropTypes.bool,
};
